import axios from "axios";
import toastr from "toastr";
import store from "../store/index";
import exemptRoutes from "../misc/exempt-routes";

export default function setup() {
  var instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_URI,
    withCredentials: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  instance.interceptors.request.use(
    function(config) {
      // Do something before request is sent
      config.headers["X-XSRF-TOKEN"] = store.state.auth.user.xsrftoken;

      var exempt = false;
      _.forEach(exemptRoutes, function(route) {
        if (
          _.includes(config.url.toLowerCase(), route.path.toLowerCase()) &&
          config.method === route.method
        ) {
          console.log("exempt route: " + config.url.toLowerCase());
          exempt = true;
        }
      });
      if (!exempt) {
        store.dispatch("spinner/addRequest");
      }

      return config;
    },
    function(error) {
      // Do something with request error
      store.dispatch("spinner/removeRequest");
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      // Do something with response data
      var exempt = false;
      _.forEach(exemptRoutes, function(route) {
        if (
          _.includes(
            response.config.url.toLowerCase(),
            route.path.toLowerCase()
          ) &&
          response.config.method === route.method
        ) {
          console.log("exempt route: " + response.config.url.toLowerCase());
          exempt = true;
        }
      });
      if (!exempt) store.dispatch("spinner/removeRequest");
      return response;
    },
    function(error) {
      store.dispatch("spinner/removeRequest");
      // Do something with response error
      console.log(error.response);

      toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: false,
        progressBar: false,
        positionClass: "toast-top-right",
        preventDuplicates: false,
        onclick: null,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "0",
        extendedTimeOut: "1000",
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "fadeOut",
      };

      // Toastr Message
      toastr.error("Status " + error.response.status, "Error");

      if (error.response.status === 401) {
        window.location.href =
          process.env.VUE_APP_BASE_URI +
          "/home/login?returnUrl=" +
          window.location.href;
        return;
      } else if (error.response.status === 403) {
        window.location.href = "/not-authorized";
      }

      return Promise.reject(error);
    }
  );

  return instance;
}
